import { render, staticRenderFns } from "./MyCustomersReport.vue?vue&type=template&id=45cabcd1&"
import script from "./MyCustomersReport.vue?vue&type=script&lang=js&"
export * from "./MyCustomersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports